<div class="column">
  <div class="search-bar">
    <mat-form-field appearance="outline" class="search--input">
      <mat-label>Search</mat-label>
      <input matInput type="text" placeholder="Type property ID or address to find" [(ngModel)]="query"
        (ngModelChange)="onFilter()">
      @if (!query) {
      <mat-icon matSuffix [svgIcon]="icons.SearchIcon" />
      }
      @if (query) {
      <button matSuffix mat-icon-button aria-label="close" (click)="clearSerch()">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="queryStatus" (ngModelChange)="onFilter()">
        <mat-select-trigger *ngIf="queryStatus">
          <app-status-indicator [isDropdownOption]="true"
                                [statusText]="queryStatus">
          </app-status-indicator>
        </mat-select-trigger>
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let entry of RentalPropertyStatusStrMap | keyvalue" [value]="entry.key">
          <app-status-indicator [isDropdownOption]="true"
                                [statusText]="entry.key"></app-status-indicator>
        </mat-option>
      </mat-select>

    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Filing frequency</mat-label>
      <mat-select [(ngModel)]="queryOccupation" (ngModelChange)="onFilter()">
        <mat-option value="*">All</mat-option>
        <mat-option *ngFor="let freq of FrequencyLabelMap | keyvalue" [value]="freq.key">{{freq.value}}</mat-option>
      </mat-select>
    </mat-form-field>
    <button class="add-property-btn" type="button" (click)="openAddPropertyDialog()"
      mat-flat-button color="primary" [disabled]="!account">
      <mat-icon fontIcon="add"></mat-icon>Add Property
    </button>
  </div>


  <div class="row">
    <app-filter-tag-container (onClearAll)="removeFilters()" (onRemoveTag)="removeFilter($event)" />
  </div>
  @if (checkedPropertyId && matches.length) {
    <div class="match-panel">
      <div class="match-panel__head">
        <span>Possible duplicates of property {{ checkedPropertyId }}</span>
        <button mat-icon-button type="button" aria-label="close" (click)="closeMatches()"><mat-icon>close</mat-icon></button>
      </div>
      @for (m of matches; track m.propertyId) {
        <app-property-match-card [match]="m" [newIsManagementCompany]="isManagementCompany" [busy]="matchBusy"
                                 (link)="linkMatch(m, $event.newIsHome)" (notSame)="dismissMatch(m)"></app-property-match-card>
      }
    </div>
  }
  <div class="mat-elevation-z8">
    <table mat-table class="full-width-table" matSort aria-label="Elements">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Property ID</th>
        <td mat-cell *matCellDef="let row">{{row.id}}</td>
      </ng-container>
      <ng-container matColumnDef="rentalPropertyStreetAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Property Address</th>
        <td mat-cell *matCellDef="let row">{{row.rentalPropertyStreetAddress}}</td>
      </ng-container>
      <ng-container matColumnDef="frequency">
        <th mat-header-cell *matHeaderCellDef>Filing Frequency</th>
        <td mat-cell *matCellDef="let row">{{row.frequency | frequency}}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          <app-status-indicator [statusText]="row.status"></app-status-indicator>
        </td>
      </ng-container>

      <ng-container matColumnDef="sharing">
        <th mat-header-cell *matHeaderCellDef>Sharing</th>
        <td mat-cell *matCellDef="let row">
          @if (sharesByProperty.get(row.id); as share) {
            <span class="share-chip">{{ shareLabel(share) }}</span>
            <button mat-button type="button" color="warn" (click)="unlink(share, $event)">Unlink</button>
          } @else {
            <button mat-button type="button" (click)="checkDuplicates(row.id, $event)">Check for duplicates</button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable"
        [routerLink]="['../../property', row.id]"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No data matching the filter.
        </td>
      </tr>
    </table>

    <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20]" aria-label="Select page">
    </mat-paginator>
  </div>
</div>
